<template>
  <div class="account-sidebar">
    <nav class="account-sidebar__nav">
      <AccountMenu
        title="Personal Information"
        routeName="ProfileInfo"
        @clicked="switchContent"
      />
      <AccountMenu
        v-if="canPerformAction('kyc:*') || canPerformAction('kyc:viewKyc')"
        title="KYC Documents"
        routeName="Kyc"
        @clicked="switchContent"
      />
      <AccountMenu
        v-if="canPerformAction('bank:*') || canPerformAction('bank:viewBank')"
        title="Bank Information"
        routeName="Bank"
        @clicked="switchContent"
      />
      <AccountMenu
        title="Security"
        routeName="Security"
        @clicked="switchContent"
      />
      <AccountMenu
        v-if="canPerformAction('configuration:*') || canPerformAction('configuration:viewConfiguration')"
        title="Configurations"
        routeName="Configuration"
        @clicked="switchContent"
      />
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AccountMenu from "@/components/navigation/AccountMenu.vue";
import { permissionsService } from "@/utils/permissionChecker.js"

export default {
  name: "AccountSidebar",
  components: { AccountMenu },
  emits: ["closeMenu", "switchLayout", "show-live-chat"],
  props: {
    layout: { type: String, default: () => "" },
  },
  data() {
    return {
      personalInformation: false,
      kycDocuments: false,
      bankInformation: false,
      security: false,
      subscriptionPlans: false,
      configuration: false,
      title: "Personal Information",
    };
  },
  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
    }),
  },
  created() {
    this.setFocus();
    this.initializePermissions()
  },
  methods: {
    switchContent(title) {
      this.title = title;
      this.$emit("closeMenu");
      this.$emit("switchLayout", title);
      this.setFocus();
    },
    setFocus() {
      this.personalInformation = false;
      this.kycDocuments = false;
      this.bankInformation = false;
      this.security = false;
      this.subscriptionPlans = false;
      this.configuration = false;
      switch (this.title) {
        case "Personal Information":
          this.personalInformation = true;
          break;
        case "KYC Documents":
          this.kycDocuments = true;
          break;
        case "Bank Information":
          this.bankInformation = true;
          break;
        case "Security":
          this.security = true;
          break;
        case "Subscription Plans":
          this.subscriptionPlans = true;
          break;
        case "Configurations":
          this.configuration = true;
          break;
        default:
          break;
      }
    },

    canPerformAction(action) {
      return permissionsService.hasPermission(action);
    },

    initializePermissions() {
      const userPermissions = permissionsService.loadUserPermissions();
    }
  },

  watch: {
    layout(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.title = this.layout;
        this.setFocus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.account-sidebar {
  &__nav {
    display: flex;
    flex-direction: column;
    padding-top: 8px;

    @media (max-width: 767px) {
      background: #FFFFFF;
      padding: 16px;
      border-radius: 12px;
      border: 1px solid #E2E8F0;
    }
  }
}
</style>
